import { HelpFeature, HelpModel } from '@/model/HelpModel';
import { HelpActionTypes } from './actionTypes';

export interface SetHelpFeaturesAction {
	type: HelpActionTypes.SET_HELP_FEATURES;
	payload: Map<HelpFeature, HelpModel[]>;
}

//Union Action Types
export type HelpAction = SetHelpFeaturesAction;

//Export Action
export const setHelpFeatures = (payload: Map<HelpFeature, HelpModel[]>): SetHelpFeaturesAction => {
	return {
		type: HelpActionTypes.SET_HELP_FEATURES,
		payload,
	};
};
